import Vue from "vue";
import AppHeading from "@/components/common/app-heading";
import AppTable from "@/components/common/app-table";
import AppSearch from "@/components/common/app-search";
import QualificationResult from "@/components/common/qualification-result";
import QualificationResultNbn from "@/components/common/qualification-result-nbn";
//TO DO: remove next line when QA is done (feature flag)
import QualificationResult5g from "@/components/common/qualification-result-5g-sq";
import QualificationForm5G from "@/components/common/qualification-form-5g-sq";
import CreateOrder5G from "@/components/common/create-order-5g-sq";
//END//
import QualificationForm from "@/components/common/qualification-form";
import QualificationFormNbn from "@/components/common/qualification-form-nbn";
import EnhancedSq from "@/components/common/enhanced-sq-results";
import EnhancedSqNbn from "@/components/common/enhanced-sq-results-nbn";
import OrderDetails from "@/components/common/order-details";
import NbnOrderItem from "@/components/orderQualification/nbn-order-item";
import NbnRealizedResource from "@/components/orderQualification/nbn-realized-resource";
import NbnRealizedService from "@/components/orderQualification/nbn-realized-service";
import NbnOrderAttachments from "@/components/orderQualification/nbn-order-attachments";
import NbnTechnicalDetails from "@/components/orderQualification/nbn-technical-details";
import AddressDialog from "@/components/orderManagement/address-dialog";
import QualificationDialog from "@/components/orderManagement/qualification-dialog";
import SignonglassOrders from "@/components/orderManagement/signonglass-orders";
import CreateOrder from "@/components/common/create-order";
import FancyButton from "@/components/common/fancy-button";
import ConfirmAction from "@/components/common/confirm-action";
import ProcessLoader from "@/components/common/process-loader";
import HTTPResponse from "@/components/common/http-response";
import ViewAppointment from "@/components/appointmentManagement/view-appointment.vue";
import RescheduleAppointment from "@/components/appointmentManagement/reschedule-appointment";
import OrderInfo from "@/components/orderManagement/order-info";
import InvalidAddress from "@/components/common/invalid-address";
import Qualification5G from "@/components/serviceQualification/qualification-5g";
import Details5G from "@/components/orderManagement/details-5g";
import TechnicalDetails from "@/components/orderManagement/technical-details";
import VonexSearch from "@/components/common/VonexSearch";
import QualificationAggregateNbn from "../components/common/qualification-aggregate-nbn.vue";
import OrderQualificationForm from "@/components/common/order-qualification-form";
import OrderQualificationResult from "@/components/common/order-qualification-result";
import QueryAvailableSlots from "@/components/nbnAppointmentManagement/query-available-slots.vue";
import AvailableSlotsResults from "@/components/nbnAppointmentManagement/available-slots-results.vue";
import ReserveNbnAppointment from "@/components/nbnAppointmentManagement/reserve-nbn-appointment.vue";
import NbnAppointmentResults from "@/components/nbnAppointmentManagement/nbn-appointment-results.vue";
import QueryNbnAppointment from "@/components/nbnAppointmentManagement/query-nbn-appointment.vue";
import ViewNbnAppointment from "@/components/nbnAppointmentManagement/view-nbn-appointment.vue";
import ViewNbnTroubleTicket from "@/components/troubleTicketManagement/view-nbn-trouble-ticket.vue";
import RescheduleNbnAppointment from "@/components/nbnAppointmentManagement/reschedule-nbn-appointment.vue";
import CreateNbnOrder from "@/components/common/create-nbn-order";
import OrderStatus from "@/components/common/order-status";
import AddOrganisation from "@/components/organisationManagement/add-organisation";
import EditOrganisation from "@/components/organisationManagement/edit-organisation";
import OrganisationForm from "@/components/organisationManagement/organisation-form";
import AddQuote from "@/components/quoteManagement/add-quote";
import EditQuote from "@/components/quoteManagement/edit-quote";
import QuoteForm from "@/components/quoteManagement/quote-form";
import NbnServiceDiagnostics from "@/components/serviceDiagnostics/nbn-service-diagnostics";
import NbnCheckListItem from "@/components/troubleTicketManagement/nbn-check-list-details";
import NbnCheckListItemFibre from "@/components/troubleTicketManagement/nbn-check-list-details-fibre";
import NbnCheckListItemHfc from "@/components/troubleTicketManagement/nbn-check-list-details-hfc";
import NbnCheckListItemFttnFttb from "@/components/troubleTicketManagement/nbn-check-list-details-fttn-fttb";
import NbnCheckListItemWireless from "@/components/troubleTicketManagement/nbn-check-list-details-wireless";
import NbnCheckListItemFttc from "@/components/troubleTicketManagement/nbn-check-list-details-fttc";
import NbnTicketForm from "@/components/troubleTicketManagement/nbn-ticket-form";
import NbnTicketDetails from "@/components/troubleTicketManagement/nbn-ticket-details";
import AddressCheck from "@/components/common/address-check";

Vue.component("app-heading", AppHeading);
Vue.component("app-table", AppTable);
Vue.component("app-search", AppSearch);
Vue.component("qualification-result", QualificationResult);
Vue.component("qualification-result-nbn", QualificationResultNbn);
Vue.component("address-check", AddressCheck);
//TO DO: remove next line when QA is done (feature flag)
Vue.component("qualification-result-5g", QualificationResult5g);
Vue.component("qualification-form-5g", QualificationForm5G);
Vue.component("create-order-5g", CreateOrder5G);
//END//
Vue.component("qualification-form", QualificationForm);
Vue.component("qualification-form-nbn", QualificationFormNbn);
Vue.component("order-qualification-form", OrderQualificationForm);
Vue.component("qualification-aggregate-nbn", QualificationAggregateNbn);
Vue.component("order-qualification-result", OrderQualificationResult);
Vue.component("enhanced-sq", EnhancedSq);
Vue.component("enhanced-sq-nbn", EnhancedSqNbn);
Vue.component("order-details", OrderDetails);
Vue.component("address-dialog", AddressDialog);
Vue.component("qualification-dialog", QualificationDialog);
Vue.component("signonglass-orders", SignonglassOrders);
Vue.component("create-order", CreateOrder);
Vue.component("fancy-button", FancyButton);
Vue.component("confirm-action", ConfirmAction);
Vue.component("create-order", CreateOrder);
Vue.component("process-loader", ProcessLoader);
Vue.component("http-response", HTTPResponse);
Vue.component("view-appointment", ViewAppointment);
Vue.component("reschedule-appointment", RescheduleAppointment);
Vue.component("order-info", OrderInfo);
Vue.component("invalid-address", InvalidAddress);
Vue.component("qualification-5g", Qualification5G);
Vue.component("details-5g", Details5G);
Vue.component("technical-details", TechnicalDetails);
Vue.component("vonex-search", VonexSearch);
Vue.component("nbn-order-item", NbnOrderItem);
Vue.component("nbn-realized-resource", NbnRealizedResource);
Vue.component("nbn-realized-service", NbnRealizedService);
Vue.component("nbn-order-attachments", NbnOrderAttachments);
Vue.component("nbn-technical-details", NbnTechnicalDetails);
Vue.component("query-available-slots", QueryAvailableSlots);
Vue.component("available-slots-results", AvailableSlotsResults);
Vue.component("reserve-nbn-appointment", ReserveNbnAppointment);
Vue.component("nbn-appointment-results", NbnAppointmentResults);
Vue.component("query-nbn-appointment", QueryNbnAppointment);
Vue.component("view-nbn-appointment", ViewNbnAppointment);
Vue.component("reschedule-nbn-appointment", RescheduleNbnAppointment);
Vue.component("create-nbn-order", CreateNbnOrder);
Vue.component("order-status", OrderStatus);
Vue.component("add-organisation", AddOrganisation);
Vue.component("edit-organisation", EditOrganisation);
Vue.component("organisation-form", OrganisationForm);
Vue.component("add-quote", AddQuote);
Vue.component("edit-quote", EditQuote);
Vue.component("quote-form", QuoteForm);
Vue.component("nbn-service-diagnostics", NbnServiceDiagnostics);
Vue.component("nbn-check-list-details", NbnCheckListItem);
Vue.component("nbn-check-list-details-fibre", NbnCheckListItemFibre);
Vue.component("nbn-check-list-details-hfc", NbnCheckListItemHfc);
Vue.component("nbn-check-list-details-fttn-fttb", NbnCheckListItemFttnFttb);
Vue.component("nbn-check-list-details-wireless", NbnCheckListItemWireless);
Vue.component("nbn-check-list-details-fttc", NbnCheckListItemFttc);
Vue.component("nbn-ticket-form", NbnTicketForm);
Vue.component("nbn-ticket-details", NbnTicketDetails);
Vue.component("view-nbn-trouble-ticket", ViewNbnTroubleTicket);
